import { Component, OnInit } from '@angular/core';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-profile-redirect',
  template: '',
  standalone: false
})
export class ProfileRedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.replace(`${environment.platformWebUrl.replace(/\/$/, '')}/profile`);
  }
}
